<script setup lang="ts">
import {onMounted, ref} from 'vue';
import {RouterView, useRoute} from 'vue-router';
import 'element-plus/dist/index.css';
import {Permission} from 'common';
import CabLink from '@/views/header/CabLink.vue';
import DashboardFilters from '@/views/dashboard/DashboardFilters.vue';
import {meHasPermission} from '@/base/me.js';

const route        = useRoute();
const isAdmin      = ref<boolean>(false);
// the landing this dashboard is mounted under (/admin/dashboard, /report/dashboard or /dashboard), from the route meta set in dashboardRoute()
const base: string = route.matched.find(r => r.meta.base)?.meta.base as string;

onMounted(async () => {
    isAdmin.value = await meHasPermission(Permission.admin);
});
</script>

<template>
    <div>
        <DashboardFilters/>
        <nav data-testid="dashboard-tabs" class="flex flex-row flex-wrap items-end px-10 border-b border-gray-200">
            <CabLink name="Overall" :to="`${base}/overall`"/>
            <CabLink name="Personeel" :to="`${base}/personeel`"/>
            <CabLink name="Initiatieven" :to="`${base}/initiatieven`"/>
            <CabLink name="Financien" :to="`${base}/financien`"/>
            <CabLink name="Toegankelijkheid" :to="`${base}/toegankelijkheid`"/>
            <CabLink name="Quadruple aim" :to="`${base}/quadruple-aim`"/>
            <CabLink name="KPI's" :to="`${base}/kpis`"/>
            <CabLink v-if="isAdmin" name="Data" :to="`${base}/data`"/>
        </nav>
        <RouterView/>
    </div>
</template>
